export const useGetQueryValue = <T extends string>(keys: T[]) => {
    const searchQuery = new URLSearchParams(window.location.search);
    const query = (keys || []).reduce(
        (prev, curr) => ({ ...prev, [`${curr}`]: searchQuery.get(curr) }),
        {} as { [K in T]: string },
    );

    return query;
};
